import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BancheComponent } from './banche.component';
import { BancheListComponent } from './banche-list/banche-list.component';
import { BancheDetailsComponent } from './banche-details/banche-details.component';
import { BancheCreateComponent } from './banche-create/banche-create.component';
import { BancheEditComponent } from './banche-edit/banche-edit.component';


const routes: Routes = [{
  path: '', component: BancheComponent, children: [
    {path: '', component: BancheListComponent},
    {
      path: 'details/:id',
       component:BancheDetailsComponent
    },
    {path: 'create',
    component:BancheCreateComponent
  },
    {path: 'edit/:id',
    component:BancheEditComponent
  }
]

}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BancheRoutingModule { }
